import { createFileRoute } from "@tanstack/react-router"
import OpenPurchaseOrdersTab from "~/components/purchaseOrder/tabs/OpenPurchaseOrdersTab"
import { WorkspacePage } from "~/components/design-system/pages"
import { usePageTracking } from "~/hooks/usePageTracking"

export const Route = createFileRoute("/_auth/procurement/purchase-orders/_layout/open")({
  component: RouteComponent,
})

function RouteComponent() {
  usePageTracking("Purchase Orders - Open")
  return (
    <WorkspacePage fillContent contentClassName="p-0">
      <OpenPurchaseOrdersTab />
    </WorkspacePage>
  )
}
